import React from 'react';
import { Info } from 'lucide-react';

const BasicInfoStep = ({ formData, errors, venueTypes, handleInputChange }) => {
    return (
        <div className="form-section">
            <h3>
                <Info size={24} />
                Basic Venue Info
            </h3>
            <p>Tell us about your venue. The name and description will be visible to event planners and attendees.</p>

            <div className="form-field required">
                <label>Venue Name</label>
                <input
                    type="text"
                    className={`wizard-input ${errors.name ? 'error' : ''}`}
                    value={formData.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    placeholder="e.g. Grand City Theater"
                    maxLength={255}
                />
                <div className={`character-counter ${formData.name.length > 200 ? 'warning' : ''}`}>
                    {formData.name.length}/255
                </div>
                {errors.name && <div className="error-message">{errors.name}</div>}
            </div>

            <div className="form-field required">
                <label>Description</label>
                <textarea
                    className={`wizard-textarea ${errors.description ? 'error' : ''}`}
                    value={formData.description}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                    placeholder="Describe the venue's atmosphere, history, types of events hosted..."
                    maxLength={1000}
                />
                <div className={`character-counter ${formData.description.length > 900 ? 'warning' : ''}`}>
                    {formData.description.length}/1000
                </div>
                {errors.description && <div className="error-message">{errors.description}</div>}
            </div>

            <div className="form-grid">
                <div className="form-field required">
                    <label>Venue Type</label>
                    <select
                        className={`wizard-select ${errors.type ? 'error' : ''}`}
                        value={formData.type}
                        onChange={(e) => handleInputChange('type', e.target.value)}
                    >
                        <option value="">Select Type</option>
                        {venueTypes.map(type => (
                            <option key={type} value={type}>{type}</option>
                        ))}
                    </select>
                    {errors.type && <div className="error-message">{errors.type}</div>}
                </div>

                <div className="form-field required">
                    <label>Capacity</label>
                    <input
                        type="number"
                        className={`wizard-input ${errors.capacity ? 'error' : ''}`}
                        value={formData.capacity}
                        onChange={(e) => handleInputChange('capacity', e.target.value)}
                        placeholder="Total venue capacity"
                        min="1"
                    />
                    {errors.capacity && <div className="error-message">{errors.capacity}</div>}
                </div>
            </div>
        </div>
    );
};

export default BasicInfoStep;
